export function handleWooCommerceNotices() {
  const notices = document.querySelectorAll(
    ".woocommerce-notices-wrapper > div"
  );

  const maxVisibleNotices = 3;

  notices.forEach((notice, index) => {
    if (index >= maxVisibleNotices) {
      notice.style.display = "none";
      return;
    }

    if (
      notice.classList.contains("woocommerce-message") ||
      notice.classList.contains("woocommerce-info")
    ) {
      setTimeout(() => {
        notice.style.transition = "opacity 0.5s, transform 0.5s";
        notice.style.opacity = "0";
        notice.style.transform = "translateY(-10px)";
        setTimeout(() => notice.remove(), 500);
      }, 5000);
    }

    if (notice.classList.contains("woocommerce-error")) {
      const closeButton = document.createElement("button");
      closeButton.textContent = "✖";
      closeButton.style.cssText = `
                background: none;
                border: none;
                font-size: 16px;
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
            `;
      closeButton.addEventListener("click", () => notice.remove());
      notice.style.position = "relative";
      notice.appendChild(closeButton);
    }
  });
}
